module.exports = __webpack_public_path__ + "media/images/sécurité 24h-24-4444f41dd39db5d00a8e5cf5da53f295.svg";